module.exports = __webpack_public_path__ + "img/collection_icon.2b267e49.svg";